$(() => {
  const loaderDiv = $('<div>').attr('id', 'process-loader').attr('style', 'margin-left: auto; margin-right: auto;display: flex;align-items: center;justify-content: center;');
  const img = $('<img>').attr('src', '/img/purchase-spinner.gif').appendTo('body').css('display', 'none');

  $('button[type="submit"]').click(function (e) {
    const btn = $(this);
    const buttons = $('button[type="submit"]');

    buttons.not(btn).attr('disabled', true);

    loaderDiv.css({width: $(this).outerWidth(), height: $(this).outerHeight()})

    loaderDiv.html(img);
    $(this).parent().append(loaderDiv);
    $(this).hide();
    img.show();
  });
});
